<template>
	<div class="q-px-sm q-px-lg-lg" @keyup.enter="goToLogSearch">
		<div class="row q-col-gutter-md" v-if="showWatchlistTitle">
			<div class="col">
				<h4 class="q-pt-md">{{ displayedWatchlist.name }}</h4>
			</div>
		</div>
		<div class="row q-col-gutter-sm justify-between">
			<div class="col-3 col-md-2">
				<q-select v-model="woodtype" :label="$t('product')" :options="woodtypeOptions" map-options emit-value/>
			</div>
			<div class="col-5 col-sm-7 col-md-3 col-lg-4">
				<species-selector v-model="species" :error="insufficientSearchParams"/>
			</div>
			<div class="col-md-2 gt-sm">
				<q-input type="text" v-model="logNo" :label="$t('logNo')" :error="insufficientSearchParams"/>
			</div>
			<div class="col-md-2 gt-sm">
				<q-input type="text" v-model="palletNo" :label="$t('palletNo')" :error="insufficientSearchParams"/>
			</div>
			<div class="col-4 col-sm-2">
				<div class="row text-right">
					<div class="col q-mt-md gt-sm">
						<q-btn color="primary"
							   class="cursor-pointer"
							   @click="resetSearchParams"
							   icon="undo"
							   size="md"
							   dense
							   flat
							   round
						>
							<q-badge color="primary" floating>{{ setFilterCount }}</q-badge>
							<q-tooltip content-class="bg-secondary">{{ $t('tooltip.resetSearchParams') }}</q-tooltip>
						</q-btn>
					</div>
					<div class="col q-mt-md gt-sm" v-if="editSearchParams">
						<q-btn color="primary"
							   @click="updateWatchlist"
							   icon="save"
							   :loading="updatingWatchlist"
							   size="md"
							   dense
							   flat
							   round
						>
							<q-tooltip content-class="bg-secondary">{{ $t('button.save') }}</q-tooltip>
						</q-btn>
					</div>
					<div class="col q-mt-md gt-sm" v-if="!editSearchParams">
						<q-btn color="primary"
							   class="cursor-pointer"
							   @click="createWatchlistFromSearchParams"
							   :disable="!sufficientSearchParamsGiven"
							   icon="star_border"
							   size="md"
							   dense
							   flat
							   round
						>
							<q-tooltip content-class="bg-secondary">{{ $t('tooltip.createWatchlistFromSearchParams') }}</q-tooltip>
						</q-btn>
					</div>
					<div class="col q-mt-md">
						<q-btn v-if="displayAdvancedSearch === false"
							   color="primary"
							   class="cursor-pointer"
							   @click="setDisplayAdvancedSearch(true)"
							   icon="add"
							   size="md"
							   dense
							   flat
							   round
						/>
						<q-btn v-else
							   color="primary"
							   class="cursor-pointer"
							   @click="setDisplayAdvancedSearch(false)"
							   icon="remove"
							   size="md"
							   dense
							   flat
							   round
						/>
					</div>
					<div class="col-6 col-md-4 q-mt-sm">
						<q-btn v-if="!editSearchParams"
							   color="primary"
							   class="cursor-pointer"
							   @click="goToLogSearch"
							   icon="search"
							   :loading="loadingLogs"
							   size="md"
							   round
						>
							<q-tooltip content-class="bg-secondary">{{ $t('button.search') }}</q-tooltip>
						</q-btn>
						<q-btn v-else
							   color="primary"
							   class="cursor-pointer"
							   @click="loadWatchlistPreview"
							   icon="search"
							   :loading="loadingLogs"
							   size="md"
							   round
						>
							<q-tooltip content-class="bg-secondary">{{ $t('button.preview') }}</q-tooltip>
						</q-btn>
					</div>
				</div>
			</div>
		</div>

		<q-slide-transition>
			<div v-if="displayAdvancedSearch" id="advanced-search" class="q-pb-sm">
				<div class="row q-col-gutter-sm lt-md">
					<div class="col-4 col-sm-5">
						<q-input type="text" v-model="logNo" :label="$t('logNo')" :error="insufficientSearchParams"/>
					</div>
					<div class="col-4 col-sm-5">
						<q-input type="text" v-model="palletNo" :label="$t('palletNo')" :error="insufficientSearchParams"/>
					</div>
					<div class="col-4 col-sm-2">
						<div class="row text-right">
							<div class="col q-mt-sm">
								<q-btn color="primary"
									   class="cursor-pointer"
									   @click="resetSearchParams"
									   icon="undo"
									   size="md"
									   dense
									   flat
									   round
								>
									<q-badge color="primary" floating>{{ setFilterCount }}</q-badge>
									<q-tooltip content-class="bg-secondary">{{ $t('tooltip.resetSearchParams') }}</q-tooltip>
								</q-btn>
							</div>
							<div class="col q-mt-sm" v-if="!editSearchParams">
								<q-btn color="primary"
									   @click="createWatchlistFromSearchParams"
									   :disable="!sufficientSearchParamsGiven"
									   icon="star_border"
									   size="md"
									   dense
									   flat
									   round
								>
									<q-tooltip content-class="bg-secondary">{{ $t('tooltip.createWatchlistFromSearchParams') }}</q-tooltip>
								</q-btn>
							</div>
							<div class="col q-mt-sm" v-if="editSearchParams">
								<q-btn color="primary"
									   @click="updateWatchlist"
									   icon="save"
									   :loading="updatingWatchlist"
									   size="md"
									   dense
									   flat
									   round
								>
									<q-tooltip content-class="bg-secondary">{{ $t('button.save') }}</q-tooltip>
								</q-btn>
							</div>
						</div>
					</div>
				</div>

				<div class="row q-col-gutter-sm">
					<div class="col-12 col-sm-6 col-md-3 col-lg-2">
						<q-select v-model="qualities"
								  :label="$t('label.qualities')"
								  :options="filterData.qualities"
								  option-value="intCustomerQualityId"
								  option-label="strCustomerQualityName"
								  :disable="!filterData.qualities.length"
								  :loading="loadingLogFilters"
								  multiple
								  use-chips
								  map-options
								  emit-value
								  clearable
						/>
					</div>
					<div class="col-12 col-sm-6 col-md-3 col-lg-2">
						<q-select v-model="structure"
								  :label="$t('label.structure')"
								  :options="filterData.structures"
								  option-value="intStructureId"
								  option-label="strStructureName"
								  :disable="!filterData.structures.length"
								  :loading="loadingLogFilters"
								  map-options
								  emit-value
								  clearable
						/>
					</div>
					<div class="col-12 col-sm-6 col-md-3 col-lg-2">
						<q-select v-model="thickness"
								  :label="$t('label.thickness')"
								  :options="filterData.thicknesses"
								  :disable="!filterData.thicknesses.length"
								  :loading="loadingLogFilters"
								  clearable
						/>
					</div>
					<div class="col-12 col-sm-6 col-md-3 col-lg-2">
						<q-select v-model="characteristic"
								  :label="$t('label.characteristic')"
								  :options="filterData.characteristics"
								  option-value="intCharacteristicId"
								  option-label="strCharacteristicName"
								  :disable="!filterData.characteristics.length"
								  :loading="loadingLogFilters"
								  map-options
								  emit-value
								  clearable
						/>
					</div>
					<div class="col-12 col-sm-6 col-md-3 col-lg-4">
						<q-input v-model="internalQuality" :label="$t('label.internalQuality')"/>
					</div>
					<div class="col-12 col-sm-6 col-md-3 col-lg-2">
						<div class="row q-col-gutter-sm">
							<div class="col-6">
								<q-input v-model="lengthFrom" :label="$t('label.length') + ' ' + $t('label.from')" :suffix="$t('unit.cm')"/>
							</div>
							<div class="col-6">
								<q-input v-model="lengthMax" :label="$t('label.length') + ' ' + $t('label.to')" :suffix="$t('unit.cm')"/>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-6 col-md-3 col-lg-2">
						<div class="row q-col-gutter-sm">
							<div class="col-6">
								<q-input v-model="widthFrom" :label="$t('label.width') + ' ' + $t('label.from')" :suffix="$t('unit.cm')"/>
							</div>
							<div class="col-6">
								<q-input v-model="widthTo" :label="$t('label.width') + ' ' + $t('label.to')" :suffix="$t('unit.cm')"/>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-6 col-md-3 col-lg-2">
						<div class="row q-col-gutter-sm">
							<div class="col-6">
								<q-input v-model="gradeFrom" :label="$t('label.grade') + ' ' + $t('label.from')"/>
							</div>
							<div class="col-6">
								<q-input v-model="gradeTo" :label="$t('label.grade') + ' ' + $t('label.to')"/>
							</div>
						</div>
					</div>
					<div class="col-12 col-sm-6 col-md-3 col-lg-2">
						<q-input v-model="info" :label="$t('label.info')"/>
					</div>
				</div>
			</div>
		</q-slide-transition>
	</div>
</template>

<script>
	import woodtypes from "@/common/woodtypes";
	import {
		SET_DISPLAY_ADVANCED_SEARCH,
		SET_EDIT_SEARCH_PARAMS,
		SET_SEARCH_FILTER_DATA,
		SET_SEARCH_PARAMS
	} from "@/store/mutations.type";
	import {CREATE_WATCHLIST_FROM_SEARCH_PARAMS, UPDATE_WATCHLIST} from "@/store/actions.type";
	import SpeciesSelector from "@/components/main/SpeciesSelector";
	import {mapGetters} from "vuex";
	import LogSearchParameterAccess from "@/mixins/LogSearchParameterAccess";
	import LogSearchMixin from "@/mixins/LogSearchMixin";
	import {INITIAL_LOG_FILTER_DATA, INITIAL_LOG_SEARCH_PARAMS} from "@/common/constants";

	export default {
		name: "Searchbar",
		mixins: [LogSearchMixin, LogSearchParameterAccess],
		components: {SpeciesSelector},
		data() {
			return {
				updatingWatchlist: false,
				woodtypeOptions: [
					{
						label: this.$t('veneer'),
						value: woodtypes.VENEER
					}
				]
			}
		},
		mounted() {
			this.$store.commit(SET_SEARCH_PARAMS, {...this.logSearchParams});
		},
		computed: {
			...mapGetters(['filterData', 'loadingLogFilters', 'editSearchParams', 'displayedWatchlist', 'displayAdvancedSearch']),
			showWatchlistTitle() {
				return this.$route.name === "watchlistDetail" && this.displayedWatchlist && this.displayedWatchlist.searchParams;
			},
			setFilterCount() {
				let count = 0;

				if (this.logSearchParams) {
					count = this.logSearchParams['qualities'].length ? 1 : 0;
					const {limit, offset, orderBy, orderDirection, qualities, ...relevantFilters} = INITIAL_LOG_SEARCH_PARAMS;

					for (let key in relevantFilters) {
						count += this.logSearchParams[key] ? 1 : 0;
					}
				}

				return count;
			}
		},
		methods: {
			async createWatchlistFromSearchParams() {
				await this.$store.dispatch(CREATE_WATCHLIST_FROM_SEARCH_PARAMS);
				this.$router.push({name: 'watchlistDetail', params: {id: this.$store.state.watchlist.watchlist.uid}});
			},
			setDisplayAdvancedSearch(display) {
				this.$store.commit(SET_DISPLAY_ADVANCED_SEARCH, display);
			},
			async updateWatchlist() {
				this.updatingWatchlist = true;
				await this.$store.dispatch(UPDATE_WATCHLIST, {
					object: this.displayedWatchlist, props: {
						searchParams: this.logSearchParams
					}
				});
				this.updatingWatchlist = false;

				this.setDisplayAdvancedSearch(false);
				this.$store.commit(SET_EDIT_SEARCH_PARAMS, false);
				this.loadWatchlistPreview();
			},
			resetSearchParams() {
				this.$store.commit(SET_SEARCH_PARAMS, INITIAL_LOG_SEARCH_PARAMS);
				this.$store.commit(SET_SEARCH_FILTER_DATA, INITIAL_LOG_FILTER_DATA);
			}
		}
	}
</script>

<style lang="scss" scoped>
	#advanced-search {
		max-height: calc(100vh - 116px);
		overflow: auto;
	}
</style>